import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';
import { getWhatsAppLink } from '../utils/whatsapp';
const HEADER_WHATSAPP_MESSAGE = 'Hola, equipo de ORIGEN. Quiero conocer más sobre sus servicios digitales.';
const navLinks = [{
  href: '#servicios',
  label: 'Servicios'
}, {
  href: '#como-funciona',
  label: 'Cómo funciona'
}, {
  href: '#aplicaciones',
  label: 'Aplicaciones'
}, {
  href: '#precios',
  label: 'Precios'
}, {
  href: '#voice',
  label: 'VOICE'
}];
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);
  return <>
      <header className="fixed top-0 w-full z-[100] bg-[#F7F4ED] border-b border-carbon/10" data-id="element-37" data-mp="3baelizdrusta">
        <div className="max-w-[1240px] mx-auto px-6 md:px-16 h-[68px] md:h-[78px] flex items-center justify-between" data-id="element-38" data-mp="3fbq4wn61yht1">
          <Link to="/" className="flex items-center" aria-label="ORIGEN — inicio" data-id="element-39" data-mp="2wldxbqq5z7at">
            <Logo variant="light" data-id="element-40" data-mp="2rm18x1jn9s64" />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-9" data-id="element-41" data-mp="2ro47i9yv4tmg">
            {navLinks.map(link => <a key={link.href} href={link.href} className="font-body text-[14px] text-carbon/60 hover:text-carbon transition-colors duration-150" data-id="element-42" data-mp="2mohthyb7n9cl">
                {link.label}
              </a>)}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:block" data-id="element-43" data-mp="35l98vwnmt4bd">
            <a href={getWhatsAppLink(HEADER_WHATSAPP_MESSAGE)} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-verde text-arena font-display font-medium text-[13px] px-5 py-2.5 rounded-[6px] hover:bg-verde-hover transition-colors duration-200" data-id="element-44" data-mp="35jy9e917yiq2">
              Hablar con ORIGEN →
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden text-carbon" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Abrir menú" aria-expanded={isMobileMenuOpen} data-id="element-45" data-mp="1wcxo8v6gwcyx">
            {isMobileMenuOpen ? <X size={22} data-id="element-46" data-mp="1ml0dtqna9p19" /> : <Menu size={22} data-id="element-47" data-mp="1mki7u2atjwg5" />}
          </button>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && <div className="fixed inset-0 z-[90] bg-arena pt-[68px] px-6 pb-10 flex flex-col md:hidden" data-id="element-48" data-mp="1cox7e8lef48i">
          <nav className="flex flex-col gap-7 mt-8" data-id="element-49" data-mp="ypxm9ax3h7h3">
            {navLinks.map(link => <a key={link.href} href={link.href} className="font-body text-xl text-carbon/80" onClick={() => setIsMobileMenuOpen(false)} data-id="element-50" data-mp="13n79ql0xb92a">
                {link.label}
              </a>)}
          </nav>
          <div className="mt-auto" data-id="element-51" data-mp="mdv7qsp7jyff">
            <a href={getWhatsAppLink(HEADER_WHATSAPP_MESSAGE)} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-full bg-verde text-arena font-display font-medium text-[15px] px-7 py-4 rounded-[6px] hover:bg-verde-hover transition-colors duration-200" onClick={() => setIsMobileMenuOpen(false)} data-id="element-52" data-mp="mf6dgy27rg96">
              Hablar con ORIGEN →
            </a>
          </div>
        </div>}
    </>;
}